import { Mascot, MascotId } from "@/shared/constants/mascotCatalog";
import { MascotContainer, MascotItemWrapper } from "./MascotSelector.styles";
import { MascotDisplay } from "./MascotDisplay";
import Tooltip from "../Tooltip";

interface MascotDropdownProps {
    catalog: readonly Mascot[];
    selectedId: MascotId | null;
    onSelected: (id: MascotId) => void;
};

export const MascotDropdown: React.FC<MascotDropdownProps> = ({
    catalog,
    selectedId,
    onSelected
}) => {
    return (
        <MascotContainer>
            {catalog.map((mascot) => (
                <Tooltip title={mascot.id} key={mascot.id}>
                    <MascotItemWrapper isSelected={mascot.id === selectedId}>
                        <MascotDisplay
                            label=""
                            src={mascot.src}
                            isSelected={mascot.id === selectedId}
                            disableScale={mascot.id === selectedId}
                            onClick={() => onSelected(mascot.id)}
                        />
                    </MascotItemWrapper>
                </Tooltip>
            ))}
        </MascotContainer>
    );
};